import {
  login,
  register,
  updateToken,
  providerLogin,
  forgotPassword,
  resetPassword,
  emailConfirmation,
  getUserProfile,
} from '../api';
import { navigate } from 'gatsby';
import { isBrowser, apiUrl, storeData, getData, removeData, storeUserData } from '../utils';
import {
  MYACCOUNT_SAVED_SEARCH,
  MYACCOUNT_MYPROPERTY,
  MYACCOUNT_DASHBOARD,
} from '../../../../urls';

const baseURL = apiUrl();

const storeToken = (data) => {
  // Store token
  if (isBrowser()) {
    storeData('sjwt', data.jwt);
    storeUserData(data.user);
  }

  updateToken(data.jwt);
};

const doRedirect = (url) => {
  if (typeof window !== `undefined`) {
    // looking for external link
    if (url.match(/https|http/)) window.location.href = url;
    else navigate(url);
  }
};

export function hasSavedSearch(userobjects) {
  if (userobjects && userobjects.length) {
    const searchList = userobjects.filter((item) => {
      return item.type === 'search'; /*&& item.state*/
    });
    if (searchList.length) return true;
  }
  return false;
}

export const loginRedirect = (services, state) => {
  if (services.isAuthenticated()) {
    // check for auth Call
    const authParams = services.getData('auth_params');

    // check for auth redirection
    const authReturn = services.getData('auth_return');
    if (authReturn) {
      // remove it
      services.removeData('auth_return');
      let token = '';
      if (authReturn.match(/(http|https)\:\/\//)) {
        token = `?jwt=${services.getData('sjwt')}`;
      }
      if (authParams) {
        const saveParamsFun = async () => {
          services.removeData('auth_params');
          const apiRes = await services.createUserobjectNoState(authParams);
          doRedirect(`${authReturn}${token}`);
        };
        saveParamsFun();
      } else {
        doRedirect(`${authReturn}${token}`);
      }
    } else {
      if (authParams) {
        const saveParamsFun = async () => {
          services.removeData('auth_params');
          await services.createUserobjectNoState(authParams);
        };
        saveParamsFun();
      }
      // Check for saved search
      if (!hasSavedSearch(state.user?.userobjects)) {
        doRedirect(MYACCOUNT_SAVED_SEARCH);
      } else {
        // Default redirect
        if (process.env.GATSBY_DEFAULT_LANDING_URL) {
          doRedirect(MYACCOUNT_MYPROPERTY);
        } else {
          doRedirect(MYACCOUNT_DASHBOARD);
        }
      }
    }
  }

  // return <p>Please Wait...</p>
};

const removeToken = (data) => {
  // Store token
  removeData('sjwt');
  removeData('suser');
};

const services = (dispatch, actions) => ({
  storeData: (key, value) => {
    storeData(key, value);
  },
  getData: (key) => {
    return getData(key);
  },
  removeData: (key) => {
    removeData(key);
  },
  registerWithEmail: (payload) => {
    dispatch(actions.authLoading());
    return register(payload)
      .then((res) => {
        // Auto confirm user
        if (res.data.user.confirmed) {
          // Login success
          storeToken(res.data);
          dispatch(actions.authProcess(res));
          return Promise.resolve(res);
        } else {
          // Email verification required
          dispatch(actions.verifyProcess(res));
        }
      })
      .catch((error) => {
        // Login failed
        if (error.response) {
          // Login error
          dispatch(
            actions.authError({
              message: error.response.data.message,
              status: error.response.status,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
        throw error;
      });
  },

  loginWithEmail: (payload) => {
    dispatch(actions.authLoading());
    return login(payload)
      .then((res) => {
        // Login success
        storeToken(res.data);
        dispatch(actions.authProcess(res));
        return Promise.resolve(res);
      })
      .catch((error) => {
        // Login failed
        if (error.response) {
          // Login error
          dispatch(
            actions.authError({
              message: error.response.data.message,
              status: error.response.status,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }

        throw error;
      });
  },

  isAuthenticated: () => {
    if (isBrowser()) {
      return !!getData('sjwt');
    } else {
      return false;
    }
  },

  logout: () => {
    if (isBrowser()) {
      removeToken();
    }
    dispatch(actions.authLogout());
  },

  // Successfully logged with the provider
  // Now logging with strapi by using the access_token (given by the provider) in props.location.search
  providerAuthLogin: (provider, params) => {
    return providerLogin({ provider: provider, params: params })
      .then((res) => {
        // Login success
        storeToken(res.data);
        dispatch(actions.authProcess(res));
      })
      .catch((error) => {
        // Login failed
        if (error.response) {
          // Login error
          dispatch(
            actions.providerLoginError({
              message: error.response.data,
              status: error.response.status,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },

  forgottenPassword: async (payload) => {
    await forgotPassword(payload)
      .then((res) => {
        // Login success
        dispatch(actions.forgotPassword(res));
      })
      .catch((error) => {
        // Failed
        if (error.response) {
          dispatch(
            actions.authError({
              message: error.response.data.message,
              status: error.response.status,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },

  resetPassword: async (payload) => {
    await resetPassword(payload)
      .then((res) => {
        // Login success
        storeToken(res.data);
        dispatch(actions.authProcess(res));
      })
      .catch((error) => {
        // failed
        if (error.response) {
          dispatch(
            actions.authError({
              message: error.response.data.message,
              status: error.response.status,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },

  emailConfirmation: async (payload) => {
    await emailConfirmation(payload)
      .then((res) => {
        // Login success
        storeToken(res.data);
        dispatch(actions.authProcess(res));
      })
      .catch((error) => {
        // Login failed
        if (error.response) {
          // Login error
          dispatch(
            actions.providerLoginError({
              message: error.response.data.message,
              status: error.response.status,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },

  getUserProfile: async (payload) => {
    dispatch(actions.loadingUserData(true));
    return getUserProfile(payload)
      .then((res) => {
        storeUserData(res.data);

        dispatch(actions.getUserData(true));
      })
      .catch((error) => {
        // failed
        if (error.response) {
          if (error.response?.data?.statusCode === 401) removeToken();
          dispatch(
            actions.tokenError({
              message: error.response.data.message,
              status: error.response.data.statusCode,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.serviceError({
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },

  resetMessage: async (payload) => {
    dispatch(actions.resetMessage(payload));
  },

  providerLogin: (provider) => {
    if (isBrowser()) {
      window.location.href = `${baseURL}/connect/${provider}?callback=${process.env.GATSBY_MYACCOUNT_URL}${window.location.search}`;
    }
  },
});

export default services;
